"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
exports.useOsmosysPathGetter = (data, pathStrOrPathFn, fallback) => {
    return react_1.useMemo(() => {
        let o = typeof pathStrOrPathFn === 'function'
            ? pathStrOrPathFn(data)
            : lodash_1.get(data, pathStrOrPathFn, fallback);
        // Allow for either objects, or a path to be returned by functions
        o =
            typeof pathStrOrPathFn === 'function' &&
                Array.isArray(o) &&
                o.every(v => typeof v === 'string')
                ? lodash_1.get(data, o, fallback)
                : o;
        return o;
    }, [data, pathStrOrPathFn, fallback]);
};
//# sourceMappingURL=useOsmosysPathGetter.js.map